import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Flip, toast, Zoom } from "react-toastify";
import { getPurchaseOrdersList, postPurchaseOrders, putPurchaseOrders } from "../api/purchaseOrdersAPI";

export const fetchPurchaseOrders = createAsyncThunk("po/fetchPurchaseOrders", async (payload, { rejectWithValue }) => {
  try {
    const response = await getPurchaseOrdersList(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});

export const addPurchaseOrder = createAsyncThunk("po/addPurchaseOrder", async (payload, { rejectWithValue }) => {
  try {
    const response = await postPurchaseOrders(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});


export const updatePurchaseOrder = createAsyncThunk("po/updatePurchaseOrder", async (payload, { rejectWithValue }) => {
  try {
    const response = await putPurchaseOrders(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});


export const purchaseOrdersSlice = createSlice({
  name: "purchaseOrders",
  initialState: {
    post: {
      status: null,
      error: null,
      data: null,
    },
    put: {
      status: null,
      error: null,
      data: null,
    },
    get: {
      status: null,
      error: null,
      list: [],
    },
  },

  extraReducers: {
    [fetchPurchaseOrders.pending]: (state) => {
      state.get.status = "loading";
    },
    [fetchPurchaseOrders.fulfilled]: (state, {payload}) => {
      const { status, data } = payload;
      if (status === 200) {
        state.get.list = data;
        state.get.error = null;
      }else{
        state.get.error = { message: `${status} - An error occurred` };
        toast.error("System error couldn't get purchase orders!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
      }
      state.get.status = 'idle';
    },
    [fetchPurchaseOrders.rejected]: (state, action) => {
      state.get.status = "idle";
      state.get.error = { message: "An error occurred" };
      console.log("***** ERROR PAYLOAD ******* ", action);
      toast.error("System error couldn't get purchase orders!", {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
    [addPurchaseOrder.pending]: (state) => {
      state.post.status = "loading";
    },
    [addPurchaseOrder.fulfilled]: (state, {payload}) => {
      const { status, data } = payload;
      if (status === 201) {
        toast.success("Purchase order saved.", {
          autoClose: 1300,
          transition: Flip,
          hideProgressBar: true,
        });
        state.post.status = "idle";
        state.post.error = null;
      }else{
        toast.warn("Couldn't save purchase order!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
        state.post.error = "Failed";
      }

      state.post.data = data;
    },
    [addPurchaseOrder.rejected]: (state, action) => {
      //state.post.status = "idle";
      state.post.error = { message: "An error occurred" };
      console.log("***** ERROR PAYLOAD ******* ", action);
      toast.error("System error couldn't save purchase order!", {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
    
    [updatePurchaseOrder.pending]: (state) => {
      state.put.status = "loading";
    },
    [updatePurchaseOrder.fulfilled]: (state, {payload}) => {
      const { status, data } = payload;
      if (status === 202) {
        toast.success("Purchase order saved.", {
          autoClose: 1300,
          transition: Flip,
          hideProgressBar: true,
        });
        state.put.status = "idle";
      }else{
        state.put.error = "Failed";
        toast.warn("Couldn't update purchase order!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
      }
      state.put.data = data;
    },
    [updatePurchaseOrder.rejected]: (state, action) => {
      state.put.status = "idle";
      state.put.error = { message: "An error occurred" };
      console.log("***** ERROR PAYLOAD ******* ", action);
      toast.error("System error couldn't update purchase order!", {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
  },
});

export default purchaseOrdersSlice.reducer;
